// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8429) return "static/chunks/f58c171e-77158eb4f154c2d5.js";
	if (chunkId === 4685) return "static/chunks/bf76e631-94e88cb9bc75d448.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2729":"c0d3f7cd","9066":"dc112a36"}[chunkId] || chunkId) + "." + {"2729":"4bcfb32f74a05a92","3953":"06813343f6a4578b","4677":"1ca15fc59de19948","5542":"df6b2069f3ed2582","7088":"eaf9326958a3fe8e","7888":"23543d0001d0a5bc","8845":"b6c71021b4a7b86a","9066":"18abc8c5e5f9652e"}[chunkId] + ".js";
};